export const DISCOVER_SEARCH_ACTION_TYPES = {
    SET_CUSTOMERS: 'discover/search/SET_CUSTOMERS',
    SET_SKUS: 'discover/search/SET_SKUS',
    SET_REPS: 'discover/search/SET_REPS',
    SET_CATEGORIES: 'discover/search/SET_CATEGORIES',
    CLEAR: 'discover/search/CLEAR',
};
